<template>
  <div class="field-group" :class="{ 'result-group': isResult }">
    <label :for="id">{{ label }}</label>
    <div class="input-with-unit" v-if="hasUnit">
      <span class="unit left" v-if="unitPosition === 'left'">{{ unit }}</span>
      <input
        :type="type"
        :id="id"
        :class="[
          isResult ? 'result-field' : 'input-field',
          { 'with-left-unit': unitPosition === 'left' },
          { 'highlight-result': highlight }
        ]"
        :value="value"
        :readonly="isResult"
        :min="min"
        :max="max"
        :step="step"
        @input="updateValue($event.target.value)"
        @change="$emit('change', $event.target.value)"
      />
      <span class="unit" v-if="unitPosition === 'right'">{{ unit }}</span>
    </div>
    <input
      v-else
      :type="type"
      :id="id"
      :class="[
        isResult ? 'result-field' : 'input-field',
        { 'highlight-result': highlight }
      ]"
      :value="value"
      :readonly="isResult"
      :min="min"
      :max="max"
      :step="step"
      @input="updateValue($event.target.value)"
      @change="$emit('change', $event.target.value)"
    />
    <span class="formula-explanation" v-if="formula">{{ formula }}</span>
  </div>
</template>

<script>
export default {
  name: "SimuladorField",
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    isResult: {
      type: Boolean,
      default: false
    },
    formula: {
      type: String,
      default: ""
    },
    unit: {
      type: String,
      default: ""
    },
    unitPosition: {
      type: String,
      default: "right",
      validator: value => ["left", "right"].includes(value)
    },
    highlight: {
      type: Boolean,
      default: false
    },
    min: {
      type: [String, Number],
      default: null
    },
    max: {
      type: [String, Number],
      default: null
    },
    step: {
      type: [String, Number],
      default: null
    }
  },
  computed: {
    hasUnit() {
      return !!this.unit;
    }
  },
  methods: {
    updateValue(value) {
      this.$emit("input", value);
    }
  }
};
</script>

<style scoped>
.field-group {
  margin-bottom: 20px;
  width: 50%;
  float: left;
  padding-right: 15px;
  box-sizing: border-box;
}

.field-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: bold;
  font-size: 1.1em;
}

.result-group label {
  color: #444;
  font-weight: 700;
}

.input-field,
.result-field {
  width: 100%;
  height: 40px;
  padding: 8px 30px 8px 10px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  transition: border-color 0.3s;
  box-sizing: border-box;
}

.input-field:focus {
  border-color: #f0512d;
  outline: none;
  box-shadow: 0 0 3px rgba(240, 81, 45, 0.3);
}

.result-field {
  background-color: #f0f0f0;
  font-weight: 600;
  color: #333;
  border-color: #d0d0d0;
}

.highlight-result {
  background-color: #fff2e0;
  border-color: #f0512d;
  color: #f0512d;
  font-weight: 700;
  font-size: 1.1em;
}

.formula-explanation {
  display: block;
  font-style: italic;
  color: #666;
  margin-top: 5px;
  font-size: 0.85em;
}

/* Estilos para unidades dentro do input */
.input-with-unit {
  position: relative;
  width: 100%;
}

.unit {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-size: 14px;
  color: #666;
  pointer-events: none;
}

.unit.left {
  left: 10px;
}

.unit:not(.left) {
  right: 10px;
}

.with-left-unit {
  padding-left: 30px !important;
}

@media screen and (max-width: 768px) {
  .field-group {
    width: 100%;
    padding-right: 0;
  }
}
</style>
